import React from 'react';
import { getLoginRedirectUri } from 'core/util/StorageRedirectRulesHelper';

import { IsMobileMaxWidth } from '../../../../core/util/WindowSize';
import { FiLinkedin, FiYoutube, FiInstagram, FiTwitter, FiFacebook, FiMapPin, FiMail, FiPhone, FiGlobe } from 'react-icons/fi';
import {
    ContactContainerStyle,
    ContentContainer,
    Title,
    ContactItem,
    ItemText,
    Link,
    SocialIcon,
    Img,
    Contents,
    AcessButton,
    ContentItemsContainer,
    FlexContainerSpaceBetween,
    HumaneLogoStyle,
    HeaderContainer,
    LogRodapeContainer,
    FlexContainerFooter,
    LinkFooter,
    LinkContainer,
    FlexContainerColumnSpace,
    FlexAccountsRedes,
    TextRede,
    SocialIcon2,
} from './ContactContainer.styled';

import HumaneLogo from '../../../../images/homepage/contact/humane.svg';
import HumaneLogoBlue from '../../../../images/homepage/contact/humaneBlue.svg';
import { useHistory } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import LogoIAS from '../../../../images/homepage/contact/LogoIAS.png';
import Selo30Anos from './assets/selo-30-anos.webp';
import { GTM_Page_Home } from 'components/GoogleTagManager';
import Colors from 'enums/Colors';
import { MdCopyright } from 'react-icons/md';
import LogoDefault from '../../../../images/logo/logo-default-text-white.png';
import { FaFacebookF, FaLinkedinIn, FaYoutube } from 'react-icons/fa';

const IsMobile = () => {
    return IsMobileMaxWidth();
};

interface IContactContainer {
    buttonDisabled?: boolean;
    isLight?: boolean;
    bottomFixedMenu?: boolean;
}

const ContactContainer = ({ buttonDisabled, isLight, bottomFixedMenu }: IContactContainer) => {
    const history = useHistory();
    const anoAtual = new Date().getFullYear();
    const { keycloak } = useKeycloak();

    const login = () => {
        GTM_Page_Home('secao_contato', 'btn_click_acessar_plataforma');
        history.push({
            pathname: '/login',
            state: { pathToRedirect: `${window.location.pathname}${window.location.search}${window.location.hash}` },
        });
    };

    const register = () => {
        GTM_Page_Home('secao_contato', 'btn_click_fazer_cadastro');
        const url = keycloak.createRegisterUrl({
            redirectUri: getLoginRedirectUri(),
        });
        location.assign(url);
    };

    return (
        <ContactContainerStyle isLight={isLight} bottomFixedMenu={bottomFixedMenu} id="contactContainer">
            <Contents>
                <LinkContainer href={'https://institutoayrtonsenna.org.br'} target="_blank" rel="noopener noreferrer">
                    <Img
                        style={{
                            width: 110,
                            marginRight: 10,
                            borderRadius: '0px 10px 0px 0px',
                        }}
                        src={Selo30Anos}
                    />
                </LinkContainer>
                <FlexContainerColumnSpace>
                    <ContentContainer>
                        <ContentItemsContainer>
                            <ContactItem isLight={isLight}>
                                <SocialIcon
                                    href="https://institutoayrtonsenna.org.br"
                                    target="_blank"
                                    onClick={() => {
                                        GTM_Page_Home('secao_contato', 'btn_click_website');
                                    }}
                                >
                                    <FiGlobe color={isLight ? Colors.Blue : Colors.White} style={{ width: '22px', height: '22px' }} />
                                    <p style={{ color: isLight ? Colors.Blue : Colors.White }}>institutoayrtonsenna.org.br</p>
                                </SocialIcon>
                            </ContactItem>
                            <ContactItem isLight={isLight}>
                                <SocialIcon
                                    href="mailto:humane@ias.org.br"
                                    target="_blank"
                                    onClick={() => {
                                        GTM_Page_Home('secao_contato', 'btn_click_email');
                                    }}
                                >
                                    <FiMail color={isLight ? Colors.Blue : Colors.White} style={{ width: '22px', height: '22px' }} />
                                    <p style={{ color: isLight ? Colors.Blue : Colors.White }}>humane@ias.org.br</p>
                                </SocialIcon>
                            </ContactItem>
                            <ContactItem isLight={isLight}>
                                <FiMapPin style={{ width: '22px', height: '22px' }} />
                                <ItemText
                                    color={isLight ? Colors.Blue : Colors.White}
                                >{`R. Dr. Fernandes Coelho, 85 - 15°. ${'\n'}São Paulo - Brasil`}</ItemText>
                            </ContactItem>
                        </ContentItemsContainer>
                    </ContentContainer>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <TextRede style={{ color: isLight ? Colors.Blue : Colors.White }}>Siga-nos nas nossas redes</TextRede>
                        <FlexAccountsRedes>
                            <SocialIcon2
                                href="https://www.linkedin.com/company/institutoayrtonsenna/mycompany/"
                                target="_blank"
                                onClick={() => {
                                    GTM_Page_Home('secao_contato', 'btn_click_linkedin');
                                }}
                            >
                                <FaLinkedinIn style={{ width: '22px', height: '22px' }} color={isLight ? Colors.Blue : Colors.White} />
                            </SocialIcon2>

                            <SocialIcon2
                                href="https://www.facebook.com/institutoayrtonsenna"
                                target="_blank"
                                onClick={() => {
                                    GTM_Page_Home('secao_contato', 'btn_click_facebook');
                                }}
                            >
                                <FaFacebookF color={isLight ? Colors.Blue : Colors.White} style={{ width: '22px', height: '22px' }} />
                            </SocialIcon2>

                            <SocialIcon2
                                href="https://www.instagram.com/institutoayrtonsenna/"
                                target="_blank"
                                onClick={() => {
                                    GTM_Page_Home('secao_contato', 'btn_click_instagram');
                                }}
                            >
                                <FiInstagram color={isLight ? Colors.Blue : Colors.White} style={{ width: '22px', height: '22px' }} />
                            </SocialIcon2>

                            <SocialIcon2
                                href="https://www.youtube.com/channel/UCJCq5ZlBsXYnhAbbZnwwjoA"
                                target="_blank"
                                onClick={() => {
                                    GTM_Page_Home('secao_contato', 'btn_click_youtube');
                                }}
                            >
                                <FaYoutube color={isLight ? Colors.Blue : Colors.White} style={{ width: '22px', height: '22px' }} />
                            </SocialIcon2>
                        </FlexAccountsRedes>
                    </div>
                </FlexContainerColumnSpace>
            </Contents>

            <FlexContainerSpaceBetween style={{ marginTop: '40px' }}>
                <div id="linksContainer" style={{ display: 'flex', gap: '15px', marginRight: '25px' }}>
                    <LinkFooter isLight={isLight}>
                        <p
                            onClick={() => {
                                GTM_Page_Home('secao_contato', 'btn_click_politica_privacidade');
                                history.push('/privacidade');
                            }}
                        >
                            Política de Privacidade
                        </p>
                    </LinkFooter>

                    <LinkFooter isLight={isLight}>
                        <p
                            onClick={() => {
                                GTM_Page_Home('secao_contato', 'btn_click_termos_uso');
                                history.push('/termos');
                            }}
                        >
                            Termos de Uso
                        </p>
                    </LinkFooter>

                    <LinkFooter
                        isLight={isLight}
                        href={'https://institutoayrtonsenna.gupy.io/'}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            GTM_Page_Home('secao_contato', 'btn_click_trabalhe_conosco');
                        }}
                    >
                        Trabalhe com a gente
                    </LinkFooter>
                </div>

                <LogRodapeContainer
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '10px', marginRight: '35px' }}
                >
                    {!IsMobile() && (
                        <>
                            <ItemText color={isLight ? Colors.Blue : Colors.White}>
                                Esta plataforma conta com recurso de acessibilidade da{' '}
                                {
                                    <a href="https://audima.co" target="_blank" rel="noopener noreferrer">
                                        Audima
                                    </a>
                                }
                                .
                            </ItemText>
                            <ItemText color={isLight ? Colors.Blue : Colors.White}>
                                Copyright {<MdCopyright />} {anoAtual} Instituto Ayrton Senna. Todos direitos reservados.
                            </ItemText>
                        </>
                    )}
                </LogRodapeContainer>
            </FlexContainerSpaceBetween>

            {IsMobile() && (
                <FlexContainerFooter style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '25px' }}>
                    <ItemText
                        color={isLight ? Colors.Blue : Colors.White}
                        style={{ paddingTop: '20px', marginLeft: '0', whiteSpace: 'nowrap', fontSize: '10px' }}
                    >
                        Esta plataforma conta com recurso de acessibilidade da{' '}
                        {
                            <a href="https://audima.co" target="_blank" rel="noopener noreferrer">
                                Audima
                            </a>
                        }
                        .
                    </ItemText>
                    <ItemText color={isLight ? Colors.Blue : Colors.White} style={{ marginLeft: '0', whiteSpace: 'nowrap', fontSize: '10px' }}>
                        Copyright {<MdCopyright />} {anoAtual} Instituto Ayrton Senna. Todos direitos reservados.
                    </ItemText>
                </FlexContainerFooter>
            )}
        </ContactContainerStyle>
    );
};

export default ContactContainer;
